module.exports = __webpack_public_path__ + "assets/img/d00461e0a25c663718680b788f4f5f74.342699be.png";